import format from 'date-fns/format'

import bgLocale from 'date-fns/locale/bg'

import store from '@/store'
import {parseISO} from "date-fns";

export default (value, date_format) => {
  if(value === null)
    return '';
  let _date_format = date_format ? date_format : store.state.dateFormat
  return format(parseISO(value), _date_format, {locale: bgLocale})
}